import { IconProps } from "./_types";

const RecordPause = ({ size = 29, color = "white", ...other }: IconProps) => {
  return (
    <svg
      width={size}
      height={size * (28 / 29)} // 원본 비율 유지
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 4.83333H9C6.97496 4.83333 5.33333 6.47496 5.33333 8.5V19.5C5.33333 21.525 6.97496 23.1667 9 23.1667H20C22.025 23.1667 23.6667 21.525 23.6667 19.5V8.5C23.6667 6.47496 22.025 4.83333 20 4.83333ZM9 3C5.96243 3 3.5 5.46243 3.5 8.5V19.5C3.5 22.5376 5.96243 25 9 25H20C23.0376 25 25.5 22.5376 25.5 19.5V8.5C25.5 5.46243 23.0376 3 20 3H9Z"
        fill={color}
      />
    </svg>
  );
};

export default RecordPause;
